import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { PageTabRail } from '@interxfi/app-components/components/page-tab-rail/page-tab-rail';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { OrderTypeListSelect } from '../../../../../../components/orders/order-type-list-select';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../components/router/router-tabbed-navigation';
import { CreateOrderDrawer } from '../../../../../../features/order/create-order-drawer';
import { OrdersTable } from '../../../../../../features/order/orders-table';
import { getPageHead } from '../../../../../../util/routing/meta';
import { useRollupViewContext } from '../../../../../../util/view-context';

export const Route = createFileRoute('/_app/_clearing-core/order/equity/_single/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.OrdersEquities,
      label: 'Single Orders',
      order: 0,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.OrdersEquities>,
  head: () => getPageHead('Orders'),
  component: OrderList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          <RequiresAccess write>
            <CreateOrderDrawer trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="New Order" size="small" />} />
          </RequiresAccess>

          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.OrdersEquities}
      prefix={<OrderTypeListSelect orderType="equity" />}
    />
  );
}

function OrderList() {
  const viewContext = useRollupViewContext();

  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <OrdersTable HeaderActions={TableHeader} view={viewContext} />
      </PageLayout.Section>
    </PageLayout>
  );
}
